<div class="layout">
  <app-sidebar 
      *ngIf="user"
      [user]="user" 
      [isCollapsed]="isCollapsed" 
      [isResponsiveMenu]="isResponsiveMenu"
      (toggleMenuEvent)="toggleMenu()"
      (logoutEvent)="handleLogout()"
      (navigationEvent)="handleNavigation($event)">
  </app-sidebar>

  <div class="content">
      <div class="content-header">
          <div class="header-left">
              <!-- Botón para abrir sidebar en móvil -->
              <button class="sidebar-toggle-button" 
                      *ngIf="isResponsiveMenu" 
                      (click)="toggleMenu()">
                  <i class="fa-solid fa-bars"></i>
              </button>
          </div>
          <div class="header-right">
              <!-- Botón Plan del Usuario -->
              <button class="plan-premium-button">
                  {{ getUserPlanText() }}
              </button>
              <!-- Botón de notificaciones con indicador -->
              <!-- <button class="notification-button" (click)="toggleSidebar()">
                  <i class="fa-regular fa-bell"></i>
                  <span class="notification-dot"></span>
              </button> -->
              <!-- Foto de perfil del usuario -->
              <div class="user-profile" (click)="toggleProfileSubmenu($event)">
                  <img [src]="getProfilePhotoUrl()" (error)="onPhotoError($event)" alt="User Profile" class="profile-picture" />
                  
                  <!-- Submenú del perfil -->
                  <div *ngIf="showProfileSubmenu && !isFreemiumUser()" class="profile-submenu">
                      <h2 class="submenu-title">Cuenta</h2>
                      <ul>
                          <li *ngIf="isCustomer() || isExpert()" (click)="navigateToProfileSection('personalData', $event)">Datos Personales</li>
                          <li *ngIf="isCustomer()" (click)="navigateToProfileSection('plan', $event)">Programa contratado</li>
                          <li *ngIf="isCoach() || isExpert()" (click)="navigateToProfileSection('mentorProfile', $event)">Datos Profesionales</li>
                          <li class="submenu-button-disabled">Notificaciones</li>
                          <li class="divider"></li>
                          <div class="submenu-buttons">
                              <li *ngIf="isAdminUserType3()" class="submenu-button-disabled">Gestionar cuenta</li>
                              <li *ngIf="isAdminUserType3()" class="submenu-button" (click)="navigateToProfileSection('switchAccount', $event)">Cambiar de cuenta</li>
                              <li class="submenu-button" (click)="handleLogout()">Cerrar sesión</li>
                          </div>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
      <div class="router-content">
          <router-outlet></router-outlet>
      </div>
  </div>
  
  <!-- Modal intrusivo de planes - Siempre visible para TODOS los usuarios -->
  <app-plan 
      [isVisible]="showPlanOverlay" 
      (closeDialogEvent)="togglePlanOverlay()">
  </app-plan>
  
  <app-complete-data-profile [isVisible]="showCompleteDataOverlay" (closeDialogEvent)="toggleCompleteDataOverlay()"></app-complete-data-profile>

  <app-notifications-sidebar [mostrado]="isSidebarOpen" (closeSidebar)="isSidebarOpen = false" />
  
  <!-- Modal de video -->
  <app-video-modal 
    [isVisible]="showVideoModal" 
    (closeDialogEvent)="closeVideoModal()">
  </app-video-modal>
  
  <!-- Botón flotante - Solo visible cuando isCompleteInfo es true -->
  <!-- <div *ngIf="user?.isCompleteInfo" class="floating-button-container"> -->
    <div class="floating-button-container">
    <button class="floating-button" (click)="onFloatingButtonClick()" 
            [title]="getFloatingButtonTooltip()">
      <i class="fas fa-lightbulb"></i>
    </button>
  </div>
</div>